import adminNavbarStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle';
import customDropdownStyle from 'assets/jss/material-dashboard-pro-react/components/customDropdownStyle';
import { primaryColor, blackColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const dashboardNavbarLinksStyle = (theme) => ({
	...adminNavbarStyle(theme),
	...customDropdownStyle(theme),
	username: {
		marginBottom: 0,
	},
	userInfoWrapper: {
		'& p': {
			marginBottom: '4px',
			'&:last-of-type': {
				marginBottom: 0,
			},
		},
	},
	dropdownUsername: {
		marginBottom: '8px!important',
		fontFamily: `${theme.fontFamily.albert.bold}!important`,
		whiteSpace: 'normal',
		lineHeight: theme.direction === 'rtl' ? '1.2 !important' : 'normal',
	},
	userType: {
		fontFamily: `${theme.fontFamily.alvar.bold}!important`,
	},
	profileIconButton: {
		marginRight: '12px',
		marginTop: 0,
		width: '40px!important',
		height: '40px!important',
		minWidth: '40px!important',
		margin: 0,
		padding: 0,
	},
	menuItem: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		padding: '16px',
		cursor: 'auto',
		width: '339px',
		[theme.breakpoints.down('sm')]: {
			width: '293px',
		},
		'&:hover': {
			backgroundColor: 'inherit!important',
		},
	},
	userInfo: {
		display: 'flex',
		alignItems: 'flex-start',
		width: '100%',
		justifyContent: 'flex-start',
		cursor: 'auto',
		fontFamily: 'inherit',
		'&:hover': {
			// backgroundColor: 'inherit',
		},
	},
	welcome: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		marginBottom: '16px',
		'& p': {
			marginBottom: 0,
			whiteSpace: 'normal',
			'&:first-of-type': {
				marginBottom: '4px',
			},
		},
	},
	logoWrapper: {
		'& img': {
			width: '65px',
			height: 'auto',
		},
	},
	dropdownButtonContainer: {
		display: 'flex',
		padding: 0,
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	dropdownButton: {
		minHeight: 'auto',
		height: '50px',
		margin: 0,
		padding: 0,
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.04)',
		},
		'& button': {
			margin: 0,
		},
		width: '100%',
	},
	menuList: {
		padding: 0,
	},
	paper: {
		paddingBottom: 0,
	},
	userProfile: {
		position: 'absolute !important',
		top: 8,
		right: 8,
		'&&': {
			boxShadow: `0 8px 8px -6px rgba(${hexToRgb(blackColor)}, 0.5) !important`,
		},
	},
	accountPicture: {
		color: primaryColor[0],
		marginRight: '0!important',
		height: '24px !important',
		width: '24px !important',
	},
	accountName: {
		marginLeft: '3px',
	},
	accountButton: {
		margin: '0px',
	},
	accountButtonLabel: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row',
	},
	accountCaret: {
		color: primaryColor[0],
		borderWidth: '3px',
		marginTop: '1px',
	},
	greeting: {
		marginRight: 24,
	},
	userNumber: {
		display: 'flex',
		alignItems: 'center',
	},
	userNumberEditButton: {
		minWidth: '20px !important',
	},
	userNumberEditIcon: {
		margin: '0 !important',
	},
});

export default dashboardNavbarLinksStyle;
